import request from "@/utils/request";

/**
 * 获取直播地址
 */
export const getLiveApi = (deviceId,password) => {
  return request.get({
    url: "device/get_live",
    data: {
      deviceId,
      password
    },
  });
};

/**
 * 云台控制
 */
export const deviceCloudCntrolApi = (data) => {
  return request.post({
    url: "device/cloud_control",
    data,
  });
};

/**
 * 获取云台控制token
 */
export const cloudControlTokenApi = () => {
  return request.get({
    url: "device/get_token",
  });
};

/**
 * 获取直播间聊天记录
 * @param data
 * @returns
 */
export const LiveRoomMsgApi = (data) => request.get({
  url: 'device/getUserMessage',
  data
})
/**
 * 直播间留言
 * @param data
 * @returns
 */
export const LiveRoomSendMsgApi = (data) => request.post({
  url: 'device/addUserMessage',
  data
})

/**
 * 获取直播间详情
 * @param deviceId
 * @returns
 */
export const getLiveDetails = (deviceId) => request.get({
  url: 'home/getLiveDetails?deviceId=' + deviceId,
})

const uploadPath = 'https://cd.ante3.com/server/wx/storage/upload'
export { uploadPath }
